module.exports = __webpack_public_path__ + "img/e16e462.png";